import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  FormControl,
  FormControlLabel,
  makeStyles,
  Typography,
} from '@material-ui/core'
import { KeyboardDateTimePicker } from '@material-ui/pickers'
import { ReactElement, useContext, useEffect, useState } from 'react'
import { QuoteContext, QuoteContextType } from '../context/QuoteContext'
import { styles } from '../Detail/styles'
import moment from 'moment'
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'
import { get, isEmpty } from 'lodash'
import { useGlobal } from '@Hooks/useGlobal'

const useStyles = makeStyles(styles)
export default function PublishDialog(): ReactElement {
  const classes = useStyles()
  const {
    publishNow: [publishNow, setPublishNow],
    quote: [quote],
    onPublish,
    dialog: [dialog, setDialog],
  } = useContext(QuoteContext) as QuoteContextType
  const [errorMessage, setErrorMessage] = useState('')
  const { wording } = useGlobal()
  const [publishTime, setPublishTime] = useState<MaterialUiPickersDate>()

  const [expireTime, setExpireTime] = useState<MaterialUiPickersDate>()

  const handleTogle = () => {
    if (!dialog) setErrorMessage('')
    setDialog(!dialog)
  }
  const handleOk = () => {
    if (isEmpty(quote.title)) {
      setErrorMessage(`กรุณาใส่ข้อมูลในช่อง Title`)
    } else if (isEmpty(quote.categories)) {
      setErrorMessage(`กรุณาเลือก Topic`)
    // } else if (isEmpty(content.author?._id)) {
    //   setErrorMessage('กรุณาเลือก author')
    // } else if (isEmpty(content.cover)) {
    //   setErrorMessage('กรุณาเลือกรูปปก')
    // } else if (isEmpty(content.share)) {
    //   setErrorMessage('กรุณาเลือกรูป share')
    // } else if (isEmpty(get(content, 'widgets[0].data[0].thumbnails'))) {
    //   setErrorMessage('กรุณาเลือกรูป thumbnails')
    } else {
      setErrorMessage('')
      handleTogle()
      onPublish(publishTime?.toDate(), expireTime?.toDate())
    }
  }
  useEffect(() => {
    setPublishTime(
      quote?.publish_time ? moment(quote?.publish_time) : undefined,
    )
    setExpireTime(
    quote?.expire_time ? moment(quote?.expire_time) : undefined,
    )
    return () => {}
  }, [quote?.publish_time, quote?.expire_time])

  useEffect(() => {
    return () => {
      setErrorMessage('')
    }
  }, [dialog])
  
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={dialog}
      onClose={handleTogle}
      maxWidth="xs"
    >
      <Box className={classes.box}>
        <form noValidate>
          <KeyboardDateTimePicker
            disabled={publishNow}
            className={classes.date}
            ampm={false}
            defaultValue={quote?.publish_time}
            fullWidth
            label="Publish datetime"
            format="DD/MM/YYYY HH:mm:ss"
            value={publishTime || null}
            size="small"
            onError={console.log}
            onChange={setPublishTime}
          />
        </form>
        <form noValidate>
          <KeyboardDateTimePicker
            className={classes.date}
            ampm={false}
            fullWidth
            defaultValue={quote?.expire_time}
            label="Expire datetime"
            format="DD/MM/YYYY HH:mm:ss"
            value={expireTime || null}
            size="small"
            onError={console.log}
            onChange={setExpireTime}
          />
        </form>
        <FormControl size="small" variant="outlined" className={classes.select}>
          <FormControlLabel
            control={
              <Checkbox
                checked={publishNow}
                onChange={() => {
                  setPublishNow(!publishNow)
                }}
                name="publishNow"
                color="primary"
              />
            }
            className={classes.form_control_select}
            label="publish now"
          />
        </FormControl>
        <Typography color="error" align="left" variant="body2">
          {errorMessage}
        </Typography>
        <DialogActions>
          <Button onClick={handleTogle} color="primary">
            Cancel
          </Button>
          <Button onClick={handleOk} color="primary">
            OK
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  )
}
